/**
 * Hotel single — room booking button handler.
 *
 * Reads data-* attributes from the "Выбрать" button, saves booking data
 * to sessionStorage, then navigates to the dedicated booking page.
 */

import {showToast} from "../../utils/toast.js";

const SESSION_KEY = "dopline_booking_data";
const TRACE_KEY = "dopline_booking_trace_id";

function makeTraceId() {
    const rand = Math.random().toString(36).slice(2, 10);
    return `dl-${Date.now()}-${rand}`;
}

export function initHotelSingleBooking() {
    document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-dopline-book-room]");
        if (!btn) return;

        const CFG = window.DOPLINE_AUTH || {};
        const user = CFG.user || {isLoggedIn: false};

        if (!user.isLoggedIn) {
            window.DoplineAuthModal?.setTab("login");
            window.DoplineAuthModal?.open();
            return;
        }

        const hotelId = btn.dataset.hotelId || "";
        const hs = btn.dataset.hs || "";
        const rateId = btn.dataset.rateId || "";

        if (!hotelId || !hs || !rateId) {
            showToast("Не удалось получить данные для бронирования. Обновите страницу и попробуйте снова.", "error");
            return;
        }

        let cancellationRules = [];
        try {
            const raw = JSON.parse(btn.dataset.cancellationRules || "[]");
            if (Array.isArray(raw)) cancellationRules = raw;
        } catch (_) {
            cancellationRules = [];
        }

        const roomData = {
            id: hotelId,
            title: btn.dataset.hotelTitle || "",
            hs,
            rateId,
            roomName: btn.dataset.roomName || "",
            price: Number(btn.dataset.price || 0),
            basePrice: Number(btn.dataset.basePrice || btn.dataset.price || 0),
            isNonRefundable: Number(btn.dataset.isNonRefundable || 0),
            partnerFee: Number(btn.dataset.partnerAffiliateFee || 0),
            agentFee: Number(btn.dataset.agentAffiliateFee || 0),
            freeCancellationBefore: btn.dataset.freeCancellationBefore || "",
            cancellationRules,
            adults: Number(btn.dataset.adults || 1),
            children: Number(btn.dataset.children || 0),
            nights: Number(btn.dataset.nights || 1),
            checkIn: btn.dataset.checkIn || "",
            checkOut: btn.dataset.checkOut || "",
            traceId: makeTraceId(),
        };


        try {
            sessionStorage.setItem(SESSION_KEY, JSON.stringify(roomData));
            sessionStorage.setItem(TRACE_KEY, roomData.traceId);
        } catch (_) {}

        const bookingPageUrl = (CFG.bookingPageUrl || "") || window.location.origin + "/hotel-booking/";
        window.location.href = bookingPageUrl;
    });
}
